export default {
  technicalErrorTitle: 'Erreur technique',
  connectionErrorTitle: 'Problème de connexion',
  badRequest: 'Désolé, la requête est invalide ou incomplète.',
  serviceUnavailable: 'Désolé, Le service est indisponible pour l\'instant.',
  serviceUnavailableWithTime: 'Désolé, Le service est indisponible pour l\'instant. Veuillez réessayer après',
  tooManyRequestError: 'Le service est indisponible pour l\'instant.',
  tooManyRequestErrorWithTime: 'Le service est indisponible pour l\'instant. Veuillez réessayer après',
  sorry: 'Désolé',
  serverError: 'Désolé, un problème est survenu lors de la requête.',
  networkError: 'Désolé, il semble y avoir un problème avec votre connexion.',
  tryAgain: ' Veuillez réessayer plus tard.',
  okButton: 'OK',
  cancelButton: 'Annuler',
  retryButton: 'Réessayer',
};
